define('apps/classrooms/views/pdf-utils/instruction-pdf',[
    "vendor/jspdf/jspdf"
],
/*eslint strict: [0, "function"]*/
function(
    jspdf
) {
    /**
     * Creates an instruction PDF with steps on how to use QR codes to log in
     * @param {string} countryCode - The country code to determine which URL to use
     */
    return function(countryCode) {
        var pdf = new jsPDF({ // eslint-disable-line new-cap
            "orientation": 'p',
            "unit": 'in',
            "format": 'letter',
        });

        // Determine the correct URL based on country code
        var qrUrl;
        switch (countryCode) {
            case 'GB':
                qrUrl = 'https://dlc.com/QRUK';
                break;
            case 'CA':
                qrUrl = 'https://dlc.com/QRCA';
                break;
            default:
                qrUrl = 'https://dlc.com/QR';
                break;
        }

        var topMargin = 1,
            textMargin = 0.25,
            leftMargin = 0.75,
            vertTarget = topMargin,
            sectionSpacer = 0.25,
            fontSize = 14,
            headerFontSize = 18,
            subHeaderFontSize = 14;

        // Set header
        pdf.setFontSize(headerFontSize);
        pdf.setFontType("bold");
        pdf.text(
            'How to Log into Your Student Account',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + sectionSpacer;

        // Set sub-header
        pdf.setFontSize(subHeaderFontSize);
        pdf.setFontType("normal");
        pdf.text(
            'Follow these quick steps to sign in.',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + sectionSpacer;

        // Set default text size and normal weight
        pdf.setFontSize(fontSize);
        pdf.setFontType("normal");

        // Step 1 - use the determined URL
        pdf.text(
            '1) Go to the login page: Open a web browser and go to ' + qrUrl + '.',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + sectionSpacer;

        // Step 2 - split into multiple lines to prevent overflow
        pdf.text(
            '2) If prompted: Click ',
            leftMargin,
            vertTarget
        );

        // Calculate position for "ALLOW" text
        var step2StartText = '2) If prompted: Click ';
        var step2StartWidth = pdf.getTextWidth(step2StartText);

        // Add "ALLOW" in bold
        pdf.setFontType("bold");
        pdf.text(
            'ALLOW',
            leftMargin + step2StartWidth,
            vertTarget
        );

        // Calculate position for remaining text
        var allowWidth = pdf.getTextWidth('ALLOW');
        pdf.setFontType("normal");
        pdf.text(
            ' to allow app.discoveryeducation.com',
            leftMargin + step2StartWidth + allowWidth,
            vertTarget
        );

        vertTarget += textMargin;
        pdf.text(
            '   to use your device\'s camera.',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + sectionSpacer;

        // Step 3 - split into multiple lines to prevent overflow
        pdf.text(
            '3) Hold up your QR code to your device\'s camera, then follow the',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin;
        pdf.text(
            '   instructions on the screen.',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + sectionSpacer + 0.2;

        // Important Notes header
        pdf.setFontSize(subHeaderFontSize);
        pdf.setFontType("normal");
        pdf.text(
            'Important Notes:',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + 0.1;

        // Important notes content
        pdf.setFontSize(fontSize);
        pdf.setFontType("normal");

        // Note 1
        pdf.text(
            '• Your QR code is only for signing in. It won\'t work with a regular phone camera.',
            leftMargin,
            vertTarget
        );

        vertTarget += textMargin + 0.1;

        // Note 2
        pdf.text(
            '• Your QR code is like a password. If you lose it or can\'t sign in, check in with',
            leftMargin,
            vertTarget
        );
        vertTarget += textMargin;
        pdf.text(
            '  your teacher for help.',
            leftMargin,
            vertTarget
        );

        return pdf;
    };
});

